import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { DataGrid } from '@mui/x-data-grid'
import { useEffect, useMemo, useState } from 'react'
import { format } from 'date-fns'

import { isValidUser } from '../../../OnlyWithFunctions'
import Button from '@mui/material/Button'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import MenuItem from '@mui/material/MenuItem'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useForm } from 'react-hook-form'
import { LOCALE_TEXT_ITA } from '../../../Charts/LOCALE_TEXT_ITA'
import Grid from '@mui/material/Grid'
import { getAccountingAdv } from '../../../services/getAccountingAdv'
import { getAccountingMonitoraggioInterno } from '../../../services/getAccountingMonitoraggio'
import * as XLSX from 'xlsx'
import dayjs from 'dayjs'
const statoPratica = [
  "In Richiesta", "In Lavorazione", "In Attesa Opzionali", "Info Complete",
  "Check Out Operatore", "Da Approvare", "Chiusa", "Annullata"
]
const tipiIns = ["Automatica Medio Rischio", "Automatica Alto Rischio","Manuale Medio Rischio","Manuale Alto Rischio"]


const AccountingMonitoraggio = () => {
  const [listaPratiche, setListaPratiche] = useState([])
  const [filteredRows, setFilteredRows] = useState([])
  const [isLoading, setIsLoading] = useState(false)


  const theme = useTheme()

  const { register, handleSubmit, setValue, getValues, watch } = useForm({
    defaultValues: {
      dataAperturaDal: null,
      dataAperturaAl: null,

    },
  })

  const watchAll = watch()

  const onFilter = async (data) => {
    setIsLoading(true)
    try {
      console.log(data)
      const response = await getAccountingMonitoraggioInterno({ body: data });
      setListaPratiche(response || []);
      setIsLoading(false)
    } catch (error) {
      console.error('Errore durante il recupero delle pratiche:', error);
      setListaPratiche([]);
      setIsLoading(false)
    }
  };
  const onGeneraExcel = () =>{
    //setOpenFilterMenu(false)
    handleSubmit(onFilter)
    generaExcel(listaPratiche)
  }

  const generaExcel = (lista) => {
    if (!lista || lista.length === 0) {
      console.log('Nessun dato disponibile per l\'export.')
      return
    }

    // Mappa i dati per l'export in Excel
      const ws = XLSX.utils.json_to_sheet(
        lista.map(item => ({
          NDG: item.ndg,
          'Codice Fiscale': item.codiceFiscale,
          'Ragione Sociale': item.ragioneSociale,
          'Data Apertura': item.dataCreazione ? dayjs(item.dataCreazione).format('DD/MM/YY') : '',
          'Stato Pratica': item.statoPratica,
          'Generato Adv': item.generatoAdv ? 'Si' : 'No',
          'Data Apertura Adv': item.dataAperturaAdv ? item.dataAperturaAdv : '',
          'Giorni Apertura': item.differenzaDate
        })),
      )
      // Crea un nuovo workbook
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Pratiche')

      // Scrive il file Excel con il nome desiderato
      XLSX.writeFile(wb, 'Lista_Pratiche.xlsx')



  }
  const columns = useMemo(
    () => [
      {
        field: 'ndg',
        headerName: 'NDG',
        type: 'string',
        filterable: false,
        flex: 1,
        valueGetter: params => params.row['ndg'],
        renderCell: params => (
          <Tooltip
            title={params.row['ndg']}
            followCursor
          >
            <Typography className="table-cell-trucate">
              {params.row['ndg']}
            </Typography>
          </Tooltip>
        ),
      },
      {
        field: 'codiceFiscale',
        headerName: 'Codice Fiscale',
        filterable: false,
        flex: 1,
        valueGetter: params =>
          params.row['codiceFiscale'],

        renderCell: params => (
          <Tooltip
            title={params.row['codiceFiscale']}
            followCursor
          >
            <Typography className="table-cell-trucate">
              {params.row['codiceFiscale']}
            </Typography>
          </Tooltip>
        ),
      },
      {
        field: 'ragioneSociale',
        headerName: 'Ragione Sociale',
        filterable: false,
        flex: 1,
        valueGetter: params =>
          params.row['ragioneSociale'],

        renderCell: params => (
          <Tooltip
            title={params.row['ragioneSociale']}
            followCursor
          >
            <Typography className="table-cell-trucate">
              {params.row['ragioneSociale']}
            </Typography>
          </Tooltip>
        ),
      },
      {
        field: 'dataCreazione',
        type: 'date',
        headerName: 'Data Apertura',
        filterable: false,
        flex: 1,
        valueGetter: params => params?.row?.createdAt,

        renderCell: params =>
          params?.row.dataCreazione ? format(new Date(params?.row.dataCreazione), 'dd/MM/yyyy') : '',
      },
      {
        field: 'statoPratica',
        headerName: 'Stato Pratica',
        sortable: true,
        filterable: false,
        flex: 1,
        valueGetter: params =>
          params.row['statoPratica'],
        renderCell: params => (
          <Tooltip
            title={params.row['statoPratica']}
            followCursor
          >
            <Typography className="table-cell-trucate">
              {params.row['statoPratica']}
            </Typography>
          </Tooltip>
        ),
      },
      {
        field: 'generatoAdv',
        headerName: 'Generato Adv',
        sortable: true,
        filterable: false,
        hide: !isValidUser('UTENTE_INTERNO'),
        flex: 1,
        valueGetter: params => {
          return params.row['generatoAdv'] ? 'Si' : 'No'
        },
        renderCell: params => {
          const isAdvGen = params.row['generatoAdv'] // booleano

          return (
              <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                <Typography className="table-cell-truncate">
                  {isAdvGen ? 'Si' : 'No'}
                </Typography>
              </Box>
          )
        },

      },
      {
        field: 'dataAperturaAdv',
        type: 'date',
        headerName: 'Data Apertura Adv',
        filterable: false,
        flex: 1,
        valueGetter: params => params?.row?.createdAt,

        renderCell: params =>
          params?.row.dataAperturaAdv ? format(new Date(params?.row.dataAperturaAdv), 'dd/MM/yyyy') : '',
      },
      ,
      {
        field: 'differenzaDate',
        headerName: 'Giorni Apertura',
        sortable: true,
        filterable: false,
        flex: 1,
        valueGetter: params => params.row['differenzaDate'] ,
        renderCell: params => (
          <Box display="flex" justifyContent="center" alignItems="center" width="100%">
            <Typography className="table-cell-truncate">
              {params.row['differenzaDate'] }
            </Typography>
          </Box>
        ),
      }

    ],
    [],
  )

  return (
    <Box sx={{ width: '100%' }}>

      <Box sx={{ padding: 2, mb: 2 }}>
        <form onSubmit={handleSubmit(onFilter)}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* Grid per mettere tutti i componenti sulla stessa linea */}
            <Grid container spacing={2} alignItems="end">
              <Grid item>
                <DatePicker
                  label="Apertura dal"
                  value={watch('dataAperturaDal')}
                  onChange={(value) => setValue('dataAperturaDal', value ? value.toISOString() : null)}
                  renderInput={(params) => <TextField variant="standard" {...params} />}
                />
              </Grid>
              <Grid item>
                <DatePicker
                  label="Apertura al"
                  value={watch('dataAperturaAl')}
                  onChange={(value) => setValue('dataAperturaAl', value ? value.toISOString() : null)}
                  renderInput={(params) => <TextField variant="standard" {...params} />}
                />
              </Grid>
              <Grid item>
                <Button type="submit" variant="outlined">
                  Filtra
                </Button>
              </Grid>
              <Grid item>
                <Button variant="outlined" onClick={onGeneraExcel}>
                  Genera Excel
                </Button>
              </Grid>
            </Grid>
          </LocalizationProvider>
        </form>
      </Box>
      {isLoading ? (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 10 }}>
          <CircularProgress />
        </Box>
      ) : (
      <Box
        sx={{
          height: 526,
          width: '100%',
          '& .utenteBase': {
            backgroundColor: theme.palette.grey.light,
            color: theme.palette.black,
          },
          '& .fieldAnalyst': {
            backgroundColor: theme.palette.blue.light,
            color: theme.palette.black,
          },
        }}
      >
        <DataGrid
          disableSelectionOnClick
          sx={{ cursor: 'url(hand.cur), pointer' }}
          rows={listaPratiche}
          columns={columns}
          //loading={isFetchingListaPratiche}
          getRowId={row => row.id}
          localeText={LOCALE_TEXT_ITA}
          sortingOrder={['asc', 'desc']}
          sortingMode="server"
          /*        onSortModelChange={(sorting) => {
                    handleChangeSorting(sorting[0]);
                  }}*/
          pagination={false}
        />
      </Box>)}
    </Box>
  )
}

export default AccountingMonitoraggio
